import { makeAutoObservable, runInAction } from 'mobx';
import { AccountItem, FetchAccountsParams } from 'types';
import { removeUndefinedFromObj } from 'utils/functions';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import { AxiosMethod } from 'enums';
import { API_V1_ADMIN_ACCOUNTS } from 'consts';

class AccountsStore {
  accounts: AccountItem[] = [];

  totalPages: number = 0;

  state: 'pending' | 'done' | 'error' = 'pending';

  constructor() {
    makeAutoObservable(this);
  }

  async fetchAccounts(params: FetchAccountsParams) {
    this.accounts = [];
    this.state = 'pending';
    const filteredParams = removeUndefinedFromObj(params);
    const { content, totalPages } = await NetworkRequestHandler.sendRequest({
      url: `${API_V1_ADMIN_ACCOUNTS}`,
      method: AxiosMethod.GET,
      params: { ...filteredParams },
    });
    runInAction(() => {
      this.accounts = content;
      this.totalPages = totalPages;
      this.state = 'done';
    });
  }
}

export default new AccountsStore();
